import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useSite, tx } from "@/lib/lang";
import Nav from "@/components/site/Nav";

export default function NotFound() {
  const { content, lang } = useSite();
  const nav = content.nav || {};

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "404 — Pagina non trovata | ETHIC ENERGY";
    // La pagina non esiste: chiediamo ai crawler di non indicizzarla (best-effort lato client).
    let robots = document.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      document.head.appendChild(robots);
    }
    robots.setAttribute("content", "noindex, follow");
    return () => {
      // Ripristina l'indicizzabilità quando si lascia la 404.
      const r = document.querySelector('meta[name="robots"]');
      if (r) r.setAttribute("content", "index, follow");
    };
  }, []);

  const isEn = lang === "en";

  return (
    <div className="min-h-screen bg-onyx text-ice pt-20">
      <Nav />

      <main
        data-testid="notfound-page"
        className="mx-auto max-w-3xl px-6 py-24 lg:py-32 text-center flex flex-col items-center"
      >
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-azure">
          {isEn ? "Error 404" : "Errore 404"}
        </p>
        <h1 className="mt-5 font-display text-5xl sm:text-6xl font-extrabold tracking-tight text-ice">
          404
        </h1>
        <h2 className="mt-4 font-display text-2xl sm:text-3xl font-bold tracking-tight text-ice">
          {isEn ? "Page not found" : "Pagina non trovata"}
        </h2>
        <p className="mt-4 max-w-xl text-sm text-muted-foreground leading-relaxed">
          {isEn
            ? "The page you are looking for doesn't exist or has been moved. Go back to the homepage or explore our solutions."
            : "La pagina che cerchi non esiste o è stata spostata. Torna alla home o esplora le nostre soluzioni."}
        </p>

        <div className="mt-9 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            data-testid="notfound-home-link"
            className="inline-flex items-center gap-2 rounded-full bg-royal px-6 py-3 text-sm font-semibold text-white hover:bg-royal/90 transition-colors"
          >
            {isEn ? "Back to homepage" : "Torna alla home"}
          </Link>
          <Link
            to="/osservatorio-energia"
            className="inline-flex items-center gap-2 rounded-full border border-ice/15 px-6 py-3 text-sm font-semibold text-ice hover:border-azure hover:text-azure transition-colors"
          >
            {tx(nav.insights_osservatorio, lang) || (isEn ? "Energy Observatory" : "Osservatorio Energia")}
          </Link>
        </div>
      </main>

      <footer className="border-t border-ice/5">
        <div className="mx-auto max-w-4xl px-6 py-6">
          <p className="font-mono text-xs text-muted-foreground/60 text-center">
            © {new Date().getFullYear()} RR Solutions srl — ETHIC ENERGY · P.IVA 02582720997
          </p>
        </div>
      </footer>
    </div>
  );
}
